import React from 'react';
import { Film, Music2, Upload, Mic } from 'lucide-react';

const SparklesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456Z" />
  </svg>
);

const Timeline = () => {
  return (
    <div className="bg-white text-gray-800 p-4 rounded-lg border border-gray-200">
      <div className="flex items-center">
        <div className="flex-shrink-0 w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
          <Film className="text-gray-500" />
        </div>
        <div className="flex-grow ml-4">
          <div className="relative">
            <div className="h-2 bg-gray-200 rounded-full"></div>
            <div className="absolute top-0 h-2 rounded-full bg-blue-500" style={{ width: '0%' }}></div>
            <div className="absolute top-[-5px] -ml-1 w-4 h-4 bg-blue-500 rounded-full border-2 border-white"></div>
          </div>
          <div className="flex justify-between text-xs mt-2 text-gray-500">
            <span>0s</span>
            <span>5s</span>
            <span>10s</span>
            <span>15s</span>
            <span>20s</span>
            <span>25s</span>
            <span>30s</span>
            <span>35s</span>
            <span>40s</span>
            <span>45s</span>
            <span>50s</span>
          </div>
        </div>
      </div>
      <div className="mt-4 p-4 bg-gray-50 rounded-lg">
        <p className="text-gray-500">Click tasks in history to add clips here.</p>
      </div>
      <div className="mt-4 flex items-center">
        <Mic className="text-gray-500" />
        <span className="ml-2 text-gray-500">Upload or generate voice over.</span>
        <button className="ml-auto p-2 bg-gray-100 rounded-lg">
          <Upload className="text-gray-500" />
        </button>
        <button className="ml-2 p-2 bg-gray-100 rounded-lg">
          <SparklesIcon />
        </button>
      </div>
      <div className="mt-4 flex items-center">
        <Music2 className="text-gray-500" />
        <span className="ml-2 text-gray-500">Upload or generate music.</span>
        <button className="ml-auto p-2 bg-gray-100 rounded-lg">
          <Upload className="text-gray-500" />
        </button>
        <button className="ml-2 p-2 bg-gray-100 rounded-lg">
          <SparklesIcon />
        </button>
      </div>
    </div>
  );
};

export default Timeline;
